export default __webpack_public_path__ + "34c2dfe9f51803c1cf1587efa07128c7.png";